import { createSlice } from "@reduxjs/toolkit";

//action value
const addDetailContent = "detailContent";

//action creator
export const addDetailContentAC = (payload) => {
  return {
    type: addDetailContent,
    payload,
  };
};

//initial state
const initialState = {
  content: "",
};

//reducer
const detailContent = (state = initialState, action) => {
  switch (action.type) {
    //addDetailContent : content 입력값 받기
    case addDetailContent:
      return { content: action.payload };
    default:
      return state;
  }
};

export default detailContent;

//=============================================
//RTK사용    //run time error

// //initial state
// const initialState = {
//   content: "",
// };

// const detailContentSlice = createSlice({
//   name: "detailContent",
//   initialState,
//   reducers: {
//     addDetailContentAC: (state, action) => {
//       // return { ...state, content: action.payload };
//       state.content = action.payload;
//     },
//   },
// });

// //AC export
// export const { addDetailContentAC } = detailContentSlice.actions;
// //reducer export
// export default detailContentSlice.reducer;
